export type Guid = string;

export const EMPTY_GUID: Guid = "00000000-0000-0000-0000-000000000000";
